import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import * as fromRNotification from './notifications.reducers';

export interface State {
  notifications: fromRNotification.State;
}

export const reducers: ActionReducerMap<State, any> = {
  notifications: fromRNotification.reducer,
};

export const selectNotificationFeatureState =
  createFeatureSelector<State>('notifications');
